var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MountingPortal",
    { attrs: { mountTo: "#modals-target", append: "" } },
    [
      _vm.isOpen
        ? _c("div", {
            staticClass: "ep-modal-backdrop",
            attrs: { "data-testid": "modal-backdrop" }
          })
        : _vm._e(),
      _vm.isOpen
        ? _c(
            "div",
            {
              ref: "modal",
              staticClass: "ep-modal",
              attrs: {
                tabindex: "-1",
                role: "dialog",
                "aria-hidden": "true",
                "aria-modal": "true",
                "data-testid": "modal"
              }
            },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }